export default "__VITE_ASSET__DQyFtAZZ__"